
seedWebServices.service('SdGridService', ['$http', '$cacheFactory',
    function ($http, $cacheFactory) {

        var serviceCache = $cacheFactory('SdGridService');

        this.resetCache = function () {
            serviceCache.removeAll();
        };

        this.appliedFilters = [];
        this.filters = [];

        //Filter visual appliedItems
        this.setAppliedFilter = function (gridID, filters) {
            this.explodeAppliedFilters(gridID);
            var gridFilter = {
                id: gridID,
                filters: filters
            };
            this.appliedFilters.push(gridFilter);
        };

        this.getAppliedFilters = function (gridID) {
            if (this.appliedFilters.length > 0) {
                for (var i = 0; i < this.appliedFilters.length; i++) {
                    if (this.appliedFilters[i].id == gridID) {
                        var gridFilters = this.appliedFilters[i];
                        break;
                    }
                }
                //var gridFilters = this.appliedFilters.find(f => f.id == gridID) FIND-FOR
                if (gridFilters)
                    return gridFilters.filters;
                else
                    return [];
            } else {
                return [];
            }
        };

        this.explodeAppliedFilters = function (gridID) {
            for (var i = 0; i < this.appliedFilters.length; i++) {
                if (this.appliedFilters[i].id == gridID) {
                    this.appliedFilters.splice(i, 1);
                }
            }
        };

        //Filter Items
        this.setFilter = function (gridID, filters) {
            this.explodeFilters(gridID);
            var gridFilter = {
                id: gridID,
                filters: filters
            };
            this.filters.push(gridFilter);
        };

        this.getFilters = function (gridID) {
            if (this.filters.length > 0) {
                for (var i = 0; i < this.filters.length; i++) {
                    if (this.filters[i].id == gridID) {
                        var gridFilters = this.filters[i];
                        break;
                    }
                }
                //var gridFilters = this.filters.find(f => f.id == gridID) FIND-FOR
                if (gridFilters)
                    return gridFilters.filters;
                else
                    return [];
            } else {
                return [];
            }
        };

        this.explodeFilters = function (gridID) {
            for (var i = 0; i < this.appliedFilters.length; i++) {
                if (this.filters[i].id == gridID) {
                    this.filters.splice(i, 1);
                }
            }
        };

}]);


